import { InternHeadline } from '../intern/headline';
import { InternSubline } from '../intern/subline';

/**
 * Model definition for Opener Hero Page
 */
export interface ContentOpenerHeroPage {
  __component: 'content.opener-hero-page';
  id: string;
  headline?: InternHeadline;
  subline?: InternSubline;
}

export function isContentOpenerHeroPage(obj: { __component?: string }): obj is ContentOpenerHeroPage {
  return obj.__component === 'content.opener-hero-page';
}
